import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const SchimmelRiss = () => {
  const pageData = {
    title: 'SCHIMMEL & RISSE',
    subtitle: 'Schadensbehebung',
    description: 'Professionelle Schimmelentfernung und Rissreparatur. Wir beseitigen die Ursachen und stellen die Bausubstanz wieder her.',
    heroImage: 'https://images.unsplash.com/photo-1751486403890-793880b12adb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxkcnl3YWxsJTIwY29uc3RydWN0aW9uJTIwaW50ZXJpb3IlMjBneXBzdW0lMjBpbnN0YWxsYXRpb258ZW58MHx8fHwxNzczNzM2Njg2fDA&ixlib=rb-4.1.0&q=85',
    features: [
      { title: 'Schimmelanalyse', description: 'Ursachenforschung und Befallsanalyse.' },
      { title: 'Schimmelentfernung', description: 'Fachgerechte Beseitigung von Schimmelpilzen.' },
      { title: 'Rissreparatur', description: 'Professionelle Sanierung von Rissen in Wänden und Decken.' },
      { title: 'Feuchtigkeitssperre', description: 'Vorbeugende Maßnahmen gegen erneuten Befall.' },
      { title: 'Oberflächenbehandlung', description: 'Desinfektion und Schutzanstrich.' },
      { title: 'Prävention', description: 'Beratung zur Vermeidung zukünftiger Schäden.' }
    ],
    benefits: [
      'Gesundes Raumklima wiederherstellen',
      'Ursachen nachhaltig beseitigen',
      'Fachgerechte Sanierung nach Norm',
      'Langfristiger Schutz',
      'Diskrete und saubere Arbeit',
      'Schnelle Reaktionszeit'
    ],
    process: [
      { title: 'Begutachtung', description: 'Analyse der Schäden und Ursachenfindung.' },
      { title: 'Sanierung', description: 'Entfernung von Schimmel oder Reparatur von Rissen.' },
      { title: 'Trocknung', description: 'Professionelle Trocknung der betroffenen Bereiche.' },
      { title: 'Prävention', description: 'Schutzmaßnahmen gegen erneuten Befall.' }
    ],
    metaKeywords: 'Schimmelentfernung Graubünden, Rissreparatur Cazis, Schimmelsanierung Schweiz'
  };

  return <ServiceTemplate {...pageData} />;
};

export default SchimmelRiss;